<template>
    <div>
        <form @submit.prevent="searchWebHooksUnity(1)" novalidate>
            <fieldset class="ec-form-secao">
                <legend><b-icon icon="funnel"></b-icon> Filtrar webhooks</legend>
                <div class="form-row align-items-end">
                    <div class="form-group col-sm-6 col-lg-2">
                        <label for="WebHook">ID do webhook</label>
                        <input type="text" inputmode="numeric" class="form-control" id="WebHook" placeholder="Ex.: 30870" v-model="filtro.webhook_id">
                    </div>
                    <div class="form-group col-sm-6 col-lg-2">
                        <label for="idcontato">ID do contato (CRM)</label>
                        <input type="text" inputmode="numeric" class="form-control" id="idcontato" placeholder="Ex.: 824723" v-model="filtro.contatoid">
                    </div>
                    <div class="form-group col-lg-3">
                        <label for="inscrito">Inscrito</label>
                        <input type="search" class="form-control" id="inscrito" placeholder="Nome do inscrito" v-model="filtro.nome_inscrito">
                    </div>
                    <div class="form-group col-sm-6 col-lg-3">
                        <label for="tipowebhook">Tipo de webhook</label>
                        <select class="custom-select" id="tipowebhook" v-model="filtro.tipoeventoaviso">
                            <option :value="0">Todos</option>
                            <option value="c">Inscrição Confirmada</option>
                            <option value="m">Matriculado</option>
                            <option value="a">Contrato Aceito</option>
                            <option value="f">Atualização Cadastral</option>
                            <option value="v">Enviar Valor Matrícula CRM</option>
                            <option value="d">Documentos</option>
                        </select>
                    </div>
                    <div class="form-group col-sm-6 col-lg-2">
                        <label for="sincronizado">Sincronizados</label>
                        <select class="custom-select" id="sincronizado" v-model="filtro.sincronizado">
                            <option :value="null">Todos</option>
                            <option :value="1">Sim</option>
                            <option :value="0">Não</option>
                        </select>
                    </div>
                </div>
                <div class="d-flex flex-wrap justify-content-end mb-3" style="gap:.5rem;">
                    <button type="button" class="btn btn-outline-primary btn-sm" @click.prevent="limparFiltro()"><b-icon icon="x-circle"></b-icon> Limpar filtros</button>
                    <button type="submit" class="btn btn-primary btn-sm"><b-icon icon="search"></b-icon> Filtrar</button>
                </div>
            </fieldset>
        </form>

        <div class="ec-listagem">
            <!-- filtros aplicados pelo formulário: cada chip remove o seu -->
            <div v-if="chipsFiltro.length" class="ec-dt__chips" aria-label="Filtros aplicados">
                <span class="ec-dt__chips-rotulo">Filtros:</span>
                <span v-for="chip in chipsFiltro" :key="chip.campo" class="ec-dt__chip">
                    <span class="ec-dt__chip-texto"><b>{{ chip.rotulo }}:</b> {{ chip.valor }}</span>
                    <button type="button" class="ec-dt__chip-remover" :aria-label="'Remover filtro ' + chip.rotulo" title="Remover filtro" @click="removerFiltro(chip.campo)">
                        <b-icon icon="x" aria-hidden="true"></b-icon>
                    </button>
                </span>
                <button v-if="chipsFiltro.length > 1" type="button" class="btn btn-link btn-sm ec-dt__chips-limpar" @click="limparFiltro()">Limpar filtros</button>
            </div>

            <div class="table-responsive ec-listagem__rolagem" :class="{ 'ec-listagem__rolagem--carregando': carregando && linhas.length }">
                <table v-ec-datatable="opcoesTabela" class="table table-sm table-hover ec-tabela mb-0" :aria-busy="carregando ? 'true' : 'false'">
                    <thead class="ec-thead">
                        <tr>
                            <th class="text-left">Inscrito</th>
                            <th data-ec-prioridade="6">ID</th>
                            <th class="text-left" data-ec-prioridade="3">Tipo</th>
                            <th class="text-left" data-ec-prioridade="4">Turma ERP</th>
                            <th data-ec-prioridade="1">Status</th>
                            <th data-ec-prioridade="2">Sincronização</th>
                            <th data-ec-prioridade="7">Origem</th>
                            <th data-ec-prioridade="3">Recebido em</th>
                            <th data-ec-prioridade="5">Notas</th>
                            <th class="text-right ec-tabela__col-acoes"><span class="sr-only">Ações</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- primeira carga: linhas "esqueleto" no lugar do modal bloqueante -->
                        <template v-if="carregando && !linhas.length">
                            <tr v-for="n in 5" :key="'sk' + n" class="ec-tabela__esqueleto">
                                <td v-for="c in totalColunas" :key="c"><span></span></td>
                            </tr>
                        </template>

                        <tr v-else-if="erro">
                            <td :colspan="totalColunas" class="ec-tabela__estado">
                                <b-icon icon="exclamation-triangle" font-scale="2" class="text-danger"></b-icon>
                                <p>Não foi possível carregar os webhooks.</p>
                                <button type="button" class="btn btn-outline-primary btn-sm" @click="recarregarLista()">Tentar novamente</button>
                            </td>
                        </tr>

                        <tr v-else-if="!linhas.length">
                            <td :colspan="totalColunas" class="ec-tabela__estado">
                                <template v-if="filtroAtivo">
                                    <b-icon icon="search" font-scale="2"></b-icon>
                                    <p>Nenhum resultado para os filtros.</p>
                                    <button type="button" class="btn btn-outline-primary btn-sm" @click="limparFiltro()">Limpar filtros</button>
                                </template>
                                <template v-else>
                                    <b-icon icon="inbox" font-scale="2"></b-icon>
                                    <p>Nenhum webhook recebido nesta unidade.</p>
                                </template>
                            </td>
                        </tr>

                        <template v-else>
                            <tr v-for="aluno_captado in linhas" :key="aluno_captado.id">
                                <td class="text-left" data-label="Inscrito">
                                    <span class="ec-tabela__principal">
                                        <template v-if="aluno_captado.nomeinscrito">{{ aluno_captado.nomeinscrito }}</template>
                                        <span v-else class="ec-tabela__vazio">—</span>
                                    </span>
                                    <small class="ec-tabela__secundario">Contato CRM {{ aluno_captado.contatoid || '—' }}</small>
                                </td>
                                <td data-label="ID">
                                    <span class="ec-tabela__principal">{{ aluno_captado.id }}</span>
                                </td>
                                <td class="text-left" data-label="Tipo">
                                    <span class="ec-status ec-status--rotulo ec-status--info">{{ descricaoTipo(aluno_captado.tipoeventoaviso) }}</span>
                                </td>
                                <td class="text-left" data-label="Turma ERP">
                                    <span v-if="aluno_captado.descricaocompleta">{{ aluno_captado.descricaocompleta }}</span>
                                    <span v-else class="ec-tabela__vazio">—</span>
                                    <small v-if="aluno_captado.turma_deleted_at != null" class="ec-tabela__secundario text-danger">
                                        <b-icon icon="exclamation-triangle"></b-icon> Turma excluída do ERP
                                    </small>
                                </td>
                                <td class="wh-col-status" data-label="Status">
                                    <span v-if="getDescricaoStatusRequisicao(aluno_captado)" class="ec-status" :class="'ec-status--' + varianteStatus(aluno_captado)">
                                        {{ getDescricaoStatusRequisicao(aluno_captado) }}
                                    </span>
                                    <span v-else class="ec-tabela__vazio">—</span>
                                </td>
                                <td data-label="Sincronização">
                                    <span v-if="aluno_captado.processado == 1" class="ec-status ec-status--sucesso">Sincronizado</span>
                                    <span v-else class="ec-status ec-status--aviso">Pendente</span>
                                </td>
                                <td data-label="Origem">
                                    <span v-if="aluno_captado.origem_inclusao" class="ec-status ec-status--rotulo ec-status--neutro">{{ aluno_captado.origem_inclusao }}</span>
                                    <span v-else class="ec-tabela__vazio">—</span>
                                </td>
                                <td data-label="Recebido em">
                                    <span class="ec-tabela__principal font-weight-normal">{{ daraHoraBrasileiro(aluno_captado.created_at) }}</span>
                                    <small class="ec-tabela__secundario">Atualizado {{ daraHoraBrasileiro(aluno_captado.updated_at) }}</small>
                                </td>
                                <td data-label="Notas">
                                    <a
                                        :href="'/Access/Unity/Unitie/'+unitie.id+'/notificacoes/webhook/'+aluno_captado.id"
                                        target="_blank"
                                        class="wh-notas"
                                        :class="{ 'wh-notas--pendente': aluno_captado.qtd_notificacoes_nao_lidas > 0 }"
                                        v-b-tooltip.hover
                                        :title="aluno_captado.qtd_notificacoes_nao_lidas > 0 ? aluno_captado.qtd_notificacoes_nao_lidas + ' nota(s) não lida(s) — abre em nova aba' : 'Abrir notas em nova aba'"
                                        :aria-label="'Notas do webhook ' + aluno_captado.id + (aluno_captado.qtd_notificacoes_nao_lidas > 0 ? ' (' + aluno_captado.qtd_notificacoes_nao_lidas + ' não lidas)' : '')"
                                    >
                                        <b-icon icon="chat-left-text"></b-icon>
                                        <span>{{ aluno_captado.qtd_notificacoes_nao_lidas > 0 ? aluno_captado.qtd_notificacoes_nao_lidas + ' não lida(s)' : 'Notas' }}</span>
                                    </a>
                                </td>
                                <td class="ec-tabela__col-acoes" data-label="Ações">
                                    <div class="ec-acoes">
                                        <!-- visualizar: indisponível quando a turma foi excluída do ERP -->
                                        <a v-if="aluno_captado.turma_deleted_at==null" :href="'/Access/Unity/Unitie/'+unitie.id+'/captacao/wh/'+aluno_captado.id" class="btn btn-sm ec-acao ec-acao--destaque" v-b-tooltip.hover title="Visualizar webhook" aria-label="Visualizar webhook"><b-icon icon="eye-fill"></b-icon></a>
                                        <span v-else class="wh-acao-indisponivel" tabindex="0" v-b-tooltip.hover title="Visualização indisponível: a turma foi excluída do ERP">
                                            <button type="button" class="btn btn-sm ec-acao" disabled aria-label="Visualizar webhook (indisponível)"><b-icon icon="eye-fill"></b-icon></button>
                                        </span>

                                        <!-- reprocessar (já processado) ou enviar para a fila de jobs (inscrição ainda não processada) -->
                                        <button v-if="podeReprocessar(aluno_captado)" type="button" class="btn btn-sm ec-acao" v-b-tooltip.hover title="Reprocessar webhook" aria-label="Reprocessar webhook" @click.prevent="modalReprocessamentoWebHook(aluno_captado)"><b-icon icon="arrow-repeat"></b-icon></button>
                                        <button v-else-if="podeEnviarFila(aluno_captado)" type="button" class="btn btn-sm ec-acao" v-b-tooltip.hover title="Enviar para a fila de processamento" aria-label="Enviar para a fila de processamento" @click.prevent="enviaParaFilaTrabalhos(aluno_captado)"><i class="fa-regular fa-paper-plane" aria-hidden="true"></i></button>
                                        <span v-else class="wh-acao-indisponivel" tabindex="0" v-b-tooltip.hover :title="motivoSemProcessamento(aluno_captado)">
                                            <button type="button" class="btn btn-sm ec-acao" disabled aria-label="Reprocessar webhook (indisponível)"><b-icon icon="arrow-repeat"></b-icon></button>
                                        </span>

                                        <button v-if="usuarioLogado.perfil_usuario==1" type="button" class="btn btn-sm ec-acao ec-acao--perigo" v-b-tooltip.hover title="Excluir webhook" aria-label="Excluir webhook" @click.prevent="MensagemExcluirWebHook(aluno_captado)"><b-icon icon="trash-fill"></b-icon></button>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>

            <ec-paginacao :paginacao="lista_web_hook" rotulo-itens="webhooks" :carregando="carregando" @ir="(pagina, url) => paginacaoWebHooks({ url: url })"></ec-paginacao>
        </div>

        <loading :id="'EnviaWebHookProcessamento'+unitie.id" titulo="Enviando WebHook para reprocessamento, Aguarde..." :sem-padding="true" gif-carregando="/imagens/carregando.gif"></loading>
        <loading :id="'EnviaWebHookProcessamentoJob'+unitie.id" titulo="Enviando WebHook para fila de Jobs, Aguarde..." :sem-padding="true" gif-carregando="/imagens/carregando.gif"></loading>
        <loading :id="'ExcluindoWebHooks'+unitie.id" titulo="Excluindo WebHook, Aguarde..." :sem-padding="true" gif-carregando="/imagens/carregando.gif"></loading>
    </div>
</template>

<script>
export default {
    props:['unitie','usuarioLogado','filtros'],
    data(){
        return{
            captados_webhook:[],
            lista_web_hook:{},
            // carregamento inline da listagem (esqueleto na 1ª carga, atenuação nas recargas)
            carregando:true,
            erro:false,
            web_hook_assinados:[],
            web_hook_matriculados:[],
            web_hook_valormatricula:[],
            filtro:{
                tipoeventoaviso:0,
                nome_inscrito:null,
                contatoid:null,
                webhook_id:null,
                sincronizado:null
            },
            url_webhooks:'/api/v1/Crm/getWebHooksUnity/',
            url_search:'/api/v1/Crm/searchWebHooksUnity/',
            complemento_url:"",
        }
    },
    computed:{
        linhas(){
            return (this.lista_web_hook && this.lista_web_hook.data) || []
        },
        totalColunas(){
            return 10
        },
        // v-ec-datatable em modo servidor: a API pagina e o formulário acima filtra
        opcoesTabela(){
            return {
                servidor: true,
                id: 'webhooks-unidade',
                filtros: false,
                exportar: this.exportarWebHooks,
                nomeArquivo: 'webhooks ' + (this.unitie.nomereduzido || this.unitie.nomecompleto || ''),
            }
        },
        // chips dos filtros já aplicados (complemento_url só é montado ao filtrar)
        chipsFiltro(){
            if(!this.complemento_url) return []
            const f = this.filtro
            const tipos = { c:'Inscrição Confirmada', m:'Matriculado', a:'Contrato Aceito', f:'Atualização Cadastral', v:'Enviar Valor Matrícula CRM', d:'Documentos' }
            const chips = []
            if(f.webhook_id!=null && f.webhook_id>0) chips.push({ campo:'webhook_id', rotulo:'ID do webhook', valor:f.webhook_id })
            if(f.contatoid!=null && f.contatoid>0) chips.push({ campo:'contatoid', rotulo:'Contato CRM', valor:f.contatoid })
            if(f.nome_inscrito!=null && f.nome_inscrito!="") chips.push({ campo:'nome_inscrito', rotulo:'Inscrito', valor:f.nome_inscrito })
            if(f.tipoeventoaviso!=0 && f.tipoeventoaviso!="") chips.push({ campo:'tipoeventoaviso', rotulo:'Tipo', valor:tipos[f.tipoeventoaviso] || f.tipoeventoaviso })
            if((f.sincronizado==0 || f.sincronizado==1) && f.sincronizado!=null) chips.push({ campo:'sincronizado', rotulo:'Sincronizados', valor:f.sincronizado==1 ? 'Sim' : 'Não' })
            return chips
        },
        // mesmas condições usadas em getFiltrosComplementares para montar a busca
        filtroAtivo(){
            const f = this.filtro
            return (f.contatoid!=null && f.contatoid>0)
                || (f.webhook_id!=null && f.webhook_id>0)
                || (f.nome_inscrito!=null && f.nome_inscrito!="")
                || (f.tipoeventoaviso!=0 && f.tipoeventoaviso!="")
                || ((f.sincronizado==0 || f.sincronizado==1) && f.sincronizado!=null)
        },
    },
    methods:{
        descricaoTipo(tipo){
            return ( tipo=='c' ? "Insc. Confirmada" : ( tipo=='a' ? "Contrato Assinado" : ( tipo=='m' ? "Matriculado":( tipo=='v' ? "Envia Valor CRM":( tipo=='f' ? "Atualização Cadastral":( tipo=='d' ? "Documentos":"Outros" ) ) ) ) ) )
        },
        // cor do badge de status: mesmas regras de getEstyloStatusInscricao
        varianteStatus(web_hook){
            const estilo = this.getEstyloStatusInscricao(web_hook) || ''
            if(estilo.indexOf('alert-success')>=0) return 'sucesso'
            if(estilo.indexOf('alert-danger')>=0) return 'erro'
            if(estilo.indexOf('alert-primary')>=0) return 'info'
            if(this.getDescricaoStatusRequisicao(web_hook)=='AVISO') return 'aviso'
            return 'neutro'
        },
        podeReprocessar(web_hook){
            return web_hook.processado==1 && web_hook.turma_deleted_at==null
        },
        podeEnviarFila(web_hook){
            return web_hook.processado==0 && web_hook.tipoeventoaviso=='c' && web_hook.enviado_job==0 && web_hook.turma_deleted_at==null
        },
        // explica por que nem reprocessar nem enviar para a fila estão disponíveis
        motivoSemProcessamento(web_hook){
            if(web_hook.turma_deleted_at!=null) return 'Indisponível: a turma foi excluída do ERP'
            if(web_hook.enviado_job==1) return 'Já enviado para a fila de processamento'
            if(web_hook.tipoeventoaviso!='c') return 'Aguardando processamento (envio manual para a fila só vale para Inscrição Confirmada)'
            return 'Reprocessamento indisponível'
        },
        // repete a última consulta (com ou sem filtros)
        recarregarLista(){
            if(this.complemento_url!=null && this.complemento_url!=""){
                this.searchWebHooksUnity(0)
            }else{
                this.getWebHooksUnity()
            }
        },
        // remove um filtro (chip) e refaz a busca com os demais
        removerFiltro(campo){
            const vazio = { tipoeventoaviso:0, nome_inscrito:null, contatoid:null, webhook_id:null, sincronizado:null }
            this.filtro[campo] = vazio[campo]
            if(this.filtroAtivo){
                this.searchWebHooksUnity(1)
            }else{
                this.limparFiltro()
            }
        },
        // v-ec-datatable: exporta todos os webhooks da consulta atual (lotes de 500)
        async exportarWebHooks({ colunas }){
            const base = this.complemento_url
                ? this.url_search + this.unitie.id + this.complemento_url.replace(/[?&]page=\d+/, '')
                : '/api/v1/Crm/getWebHooksUnity/' + this.unitie.id
            const valores = {
                'Inscrito': wh => wh.nomeinscrito || '',
                'ID': wh => wh.id,
                'Tipo': wh => this.descricaoTipo(wh.tipoeventoaviso),
                'Turma ERP': wh => (wh.descricaocompleta || '') + (wh.turma_deleted_at != null ? ' (turma excluída do ERP)' : ''),
                'Status': wh => this.getDescricaoStatusRequisicao(wh) || '',
                'Sincronização': wh => wh.processado == 1 ? 'Sincronizado' : 'Pendente',
                'Origem': wh => wh.origem_inclusao || '',
                'Recebido em': wh => this.daraHoraBrasileiro(wh.created_at),
                'Notas': wh => wh.qtd_notificacoes_nao_lidas > 0 ? wh.qtd_notificacoes_nao_lidas + ' não lida(s)' : '',
            }
            const exportadas = colunas.filter(c => valores[c])
            // o contato do CRM fica numa coluna própria, logo após o inscrito
            const cabecalho = []
            exportadas.forEach(c => { cabecalho.push(c); if(c === 'Inscrito') cabecalho.push('Contato CRM') })

            const linhas = []
            let pagina = 1
            let ultima = 1
            do {
                const url = base + (base.indexOf('?') >= 0 ? '&' : '?') + 'por_pagina=500&page=' + pagina
                const response = await axios.get(url)
                const dados = response.data.webhooks || {}
                ultima = dados.last_page || 1
                for(const wh of dados.data || []){
                    const linha = []
                    exportadas.forEach(c => { linha.push(valores[c](wh)); if(c === 'Inscrito') linha.push(wh.contatoid || '') })
                    linhas.push(linha)
                }
                pagina++
            } while(pagina <= ultima)
            return { cabecalho, linhas }
        },
        // volta os filtros ao estado inicial e lista todos os webhooks
        limparFiltro(){
            this.filtro = { tipoeventoaviso:0, nome_inscrito:null, contatoid:null, webhook_id:null, sincronizado:null }
            this.complemento_url = ""
            this.getWebHooksUnity()
        },
        enviaParaFilaTrabalhos(web_hook){
            var resposta = confirm("Você realmente deseja enviar este WebHook para a fila de Jobs?\nSe sim, após clicar no OK aguarde outra Mensagem Informando o Sucesso do Envio para Fila de Jobs");

            if(resposta == true){
                this.sendWebhookJob(web_hook);
            }
        },
        modalReprocessamentoWebHook(web_hook){
            var resposta = confirm("Você realmente deseja enviar este WebHook para reprocessamento?");

            if(resposta == true){
                this.reprocessWebhook(web_hook);
                //window.alert("WebHook Enviado para Reprocessamento com sucesso")
            }
        },
        sendWebhookJob(web_hook){
                $('#EnviaWebHookProcessamentoJob'+this.unitie.id).modal('show');
                let url='/api/v1/Crm/Unity/'+this.unitie.id+'/sendWebHookJob/webhook'                             
                let formData = new FormData();
                formData.append('_method','post');
                formData.append('web_hook', web_hook.id)
                let configuracao = {
                    // method:'put',
                    // headers:{
                    // //     'Accept': 'application/json',
                    // //     'Authorization': this.$root.token()
                    // },
                }
                
                axios.post(url, formData,configuracao)
                    .then(response => {
                        console.log('response.data.webhook',response.data)

                        if(response.data.erro==false){
                            web_hook.enviado_job = 1;
                            $('#EnviaWebHookProcessamentoJob'+this.unitie.id).modal('hide');
                            window.alert(response.data.mensagem)
                        }
                        
                    })
                    .catch(errors => {
                        this.errors = errors.response.data.errors
                        console.log(errors.response.data)
                        $('#EnviaWebHookProcessamentoJob'+this.unitie.id).modal('hide');
                        window.alert('houve um erro ao enviar o webhook para reprocessamento')

                    })

                    
                    
            // }
        },
        reprocessWebhook(web_hook){
                $('#EnviaWebHookProcessamento'+this.unitie.id).modal('show');
                let url='/api/v1/Crm/Unity/'+this.unitie.id+'/resend/webhook'                             
                let formData = new FormData();
                formData.append('_method','post');
                formData.append('web_hook', web_hook.id)
                let configuracao = {
                    // method:'put',
                    // headers:{
                    // //     'Accept': 'application/json',
                    // //     'Authorization': this.$root.token()
                    // },
                }
                
                axios.post(url, formData,configuracao)
                    .then(response => {
                        console.log(response.data)

                        if(response.data.erro==false){
                            //this.SemProcessamentoTotal = response.data.total
                            $('#EnviaWebHookProcessamento'+this.unitie.id).modal('hide');
                            this.getWebHooksUnity();
                            
                            window.alert(response.data.mensagem)
                        }
                        
                    })
                    .catch(errors => {
                        this.errors = errors.response.data.errors
                        console.log(errors.response.data)
                        $('#EnviaWebHookProcessamento'+this.unitie.id).modal('hide');
                        window.alert('houve um erro ao enviar o webhook para reprocessamento')

                    })

                    
                    
            // }
        },
        MensagemExcluirWebHook(web_hook){
            var resposta = confirm("Você realmente deseja Excluir este WebHook?\nSe sim, após clicar no OK aguarde outra Mensagem Informando o Sucesso da Exclusão do WebHook");

            if(resposta == true){
                this.excluirWebHook(web_hook);
            }
        },
        excluirWebHook(web_hook){
            
            $('#ExcluindoWebHooks'+this.unitie.id).modal('show');
            console.log('id',web_hook.id)
            var config = {
            method: 'delete',
            url: '/api/v1/Crm/webhook/'+web_hook.id,
            // headers: {
            //         'Accept': 'application/json',
            //         'Authorization': this.$root.token(),
            //     },
            };
            //executa requisição
            axios(config)
            .then(response => {
                console.log(response);
                if(response.data.error==false){
                   
                   window.alert(response.data.mensagem)
                }else{
                    window.alert(response.data.mensagem)
                }
                $('#ExcluindoWebHooks'+this.unitie.id).modal('hide');
                // recarrega a página atual com os mesmos filtros
                this.recarregarLista();
            })
            .catch(error => {
                window.alert(error)
                $('#ExcluindoWebHooks'+this.unitie.id).modal('hide');
            });
        },
        /*getEstyloStatusInscricao(web_hook){
            var status = (web_hook.tipoeventoaviso=='c' && web_hook.status_inscricao!=null ?
                    web_hook.status_inscricao : (web_hook.tipoeventoaviso=='a' && web_hook.status_post_contrato!=null ? 
                        web_hook.status_post_contrato  : (web_hook.tipoeventoaviso=='a' && web_hook.status_inscricao!=null ? 
                            web_hook.status_inscricao : (web_hook.tipoeventoaviso=='m' && web_hook.status_inscricao!=null ? 
                                web_hook.status_inscricao : (web_hook.tipoeventoaviso=='v' && web_hook.status_valormatricula!=null ? 
                                    web_hook.status_valormatricula : web_hook.status
                                )
                            )
                        )
                    )
                )
                console.log(status,web_hook.id,web_hook.tipoeventoaviso);
            if(web_hook.processado == 1 && status=='success' && web_hook.requisicao_id>0){
                return 'alert alert-success text-center'
            }else if (web_hook.processado == 1 && status=='error' && web_hook.requisicao_id>0){
                return 'alert alert-danger text-center'
            }else if(web_hook.processado==1 && status=='pending'){
                return 'alert alert-primary text-center'
            }
        },*/
        getEstyloStatusInscricao(web_hook){
            if(web_hook.processado == 1 && ( ( (web_hook.status_inscricao=='success' || web_hook.status_post_contrato =='success' || web_hook.status_valormatricula=='success') && web_hook.requisicao_id>0 ) || (web_hook.status_atualizacao_cadastral=='success') || (web_hook.status=='success'))){
                return 'alert alert-success text-center'
            }else if (web_hook.processado == 1 && web_hook.status_inscricao=='error' && web_hook.requisicao_id>0){
                return 'alert alert-danger text-center'
            }else if(web_hook.processado==1 && web_hook.status_inscricao=='pending'){
                return 'alert alert-primary text-center'
            }
        },
        getEstyloStatusRequisicao(web_hook){
            if(web_hook.status=='success' && web_hook.requisicao_id>0){
                return 'alert alert-success text-center'
            }else if (web_hook.requisicao_id>0){
                return 'alert alert-danger text-center'
            }else if(web_hook.processado==1 && web_hook.status!='success' && web_hook.status!='Não Foi possível obter dados da Oportunidade no CRM.'){
                return 'alert alert-primary text-center'
            }else if(web_hook.processado==0 && web_hook.status=='Reprocessar WebHook'){
                return 'alert alert-warning text-center text-danger bg-warning'
            }else if(web_hook.processado==1 && web_hook.status=='Não Foi possível obter dados da Oportunidade no CRM.'){
                return 'alert alert-danger text-center'
            }
        },
        getEstyloDescricaoStatusRequisicao(aluno_captado){
            var status = (aluno_captado.tipoeventoaviso=='c' && aluno_captado.status_inscricao!=null ?
                    aluno_captado.status_inscricao : (aluno_captado.tipoeventoaviso=='a' && aluno_captado.status_post_contrato!=null ? 
                        aluno_captado.status_post_contrato  : (aluno_captado.tipoeventoaviso=='a' && aluno_captado.status_inscricao!=null ? 
                            aluno_captado.status_inscricao : (aluno_captado.tipoeventoaviso=='m' && aluno_captado.status_inscricao!=null ? 
                                aluno_captado.status_inscricao : (aluno_captado.tipoeventoaviso=='v' && aluno_captado.status_valormatricula!=null ? 
                                    aluno_captado.status_valormatricula : aluno_captado.status
                                )
                            )
                        )
                    )
                )

            
            if(status==null || status==''){
                return status;
            }else if(status=='success' || status==2){
                return 'SUCESSO'
            }else if (status=='error' || status==3){
                return 'ERRO'
            }else if(status=='pending' || status==1){
                return 'PENDENTE'
            }else if(status=='warning' || status==4){
                return 'AVISO'
            }else {
                return status
            }
        },
        getDescricaoStatusRequisicao(aluno_captado){
            var status = (aluno_captado.tipoeventoaviso=='c' && aluno_captado.status_inscricao!=null ?
                    aluno_captado.status_inscricao : (aluno_captado.tipoeventoaviso=='a' && aluno_captado.status_post_contrato!=null ? 
                        aluno_captado.status_post_contrato  : (aluno_captado.tipoeventoaviso=='a' && aluno_captado.status_inscricao!=null ? 
                            aluno_captado.status_inscricao : (aluno_captado.tipoeventoaviso=='m' && aluno_captado.status_inscricao!=null ? 
                                aluno_captado.status_inscricao : (aluno_captado.tipoeventoaviso=='v' && aluno_captado.status_valormatricula!=null ? 
                                    aluno_captado.status_valormatricula : (aluno_captado.tipoeventoaviso=='f' && aluno_captado.status_atualizacao_cadastral!=null ? 
                                        aluno_captado.status_atualizacao_cadastral : (aluno_captado.tipoeventoaviso=='d' && aluno_captado.status!=null ? 
                                            aluno_captado.status : aluno_captado.status
                                        )
                                        
                                    )
                                )
                            )
                        )
                    )
                )

            if(status==null || status==''){
                return status;
            }else if(status=='success' || status==2){
                return 'SUCESSO'
            }else if (status=='error' || status==3){
                return 'ERRO'
            }else if(status=='pending' || status==1){
                return 'PENDENTE'
            }else if(status=='warning' || status==4){
                return 'AVISO'
            }else {
                return status
            }
        },
        paginacaoWebHooks(link){

            var arrPage = link.url.split("page");

            var page = (arrPage.length > 0 ? arrPage[arrPage.length-1].split("=") : 0 )
            
            this.getFiltrosComplementares(page[page.length - 1])

            console.log("link",page[page.length - 1])
            console.log("Paginacao",this.complemento_url)
            var testeUrl = this.complemento_url.split("=")
            if(this.complemento_url!=null && this.complemento_url!=""){
                
                this.searchWebHooksUnity(0);
                console.log("Aqui 1")

            }else if(link.url){
                
                //this.url_webhooks = link.url; // ajustando a url com parâmetros de pagina
                
                //  console.log(this.urlUnidades)
                this.url_webhooks = '/api/v1/Crm/getWebHooksUnity/'+this.unitie.id + (page.length>0 && page[page.length - 1] > 1 ? "?page="+page[page.length - 1]:"")
                this.getWebHooksUnity();
                console.log("Aqui 2")
                // console.log('paginacaoWebHooks',link.url)
            }

        },        
        converteJsonObjeto(dados){
            
            //var x = JSON.stringify(dados.substring(1,dados.length-1),null,'\t');
            var a = JSON.parse(dados)
            // console.log('a',a)
            return a
        },
        daraHoraBrasileiro(date){
            let dataHora = new Date(date)
            // let dataHoraUtc = new Date()
            return dataHora.toLocaleString('pt-BR', { timezone: 'UTC' })
        },
        formatDate(date,idioma) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;

            if(idioma==1){
                let dt = [year, month, day].join('-');
                if(dt=='1969-12-31'){
                    return null
                }else{
                    return dt;
                }
            }else if(idioma==2){
                let dt = [day, month, year].join('/');
                if(dt=='31/12/1969'){
                    return null
                }else{
                    return dt;
                }
            }else{
                let dt = [year, month, day].join('-');
                if(dt=='1969-12-31'){
                    return null
                }else{
                    return dt;
                }
            }
        },
        getWebHooksUnity(){
            console.log(this.unitie);
            this.carregando = true
            this.erro = false
            //this.url_webhooks = this.url_webhooks+this.unitie.id

            console.log('URL: ' + this.paginacaoWebHooks)
            var config = {
                method: 'get',
                url: this.url_webhooks,
                // headers: {
                //         'Accept': 'application/json',
                //         'Authorization': this.$root.token(),
                //     },
                };
                //executa requisição
                axios(config)
                .then(response => {
                    this.lista_web_hook = response.data.webhooks
                    this.carregando = false
                })
                .catch(error => {
                    // erro exibido na própria tabela, com "Tentar novamente"
                    console.log('error',error);
                    this.erro = true
                    this.carregando = false
                    //this.erro = error
                    // console.log(error);
                });
                
                
        
        },
        getFiltrosComplementares(pagina = 0){
            this.complemento_url = "";

            if(this.filtro.contatoid!=null && this.filtro.contatoid>0){
                this.complemento_url = this.complemento_url + "&contatoid="+""+this.filtro.contatoid+""
            }else{
                this.complemento_url = this.complemento_url
            }

            if(this.filtro.webhook_id!=null && this.filtro.webhook_id>0){
                this.complemento_url = this.complemento_url + "&webhook_id="+""+this.filtro.webhook_id+""
            }else{
                this.complemento_url = this.complemento_url
            }

            if(this.filtro.nome_inscrito!=null && this.filtro.nome_inscrito!=""){
                this.complemento_url = this.complemento_url + "&nome_inscrito="+""+this.filtro.nome_inscrito+""
            }else{
                this.complemento_url = this.complemento_url
            }

            if(this.filtro.tipoeventoaviso!=0 && this.filtro.tipoeventoaviso!=""){
                this.complemento_url = this.complemento_url + "&tipoeventoaviso="+""+this.filtro.tipoeventoaviso+""
            }else{
                this.complemento_url = this.complemento_url
            }

            if((this.filtro.sincronizado==0 || this.filtro.sincronizado==1) && this.filtro.sincronizado!=null){
                this.complemento_url = this.complemento_url + "&sincronizado="+this.filtro.sincronizado
            }else{
                this.complemento_url = this.complemento_url + "";
            }

            this.complemento_url=(this.complemento_url!="" ? "?"+this.complemento_url.substring(1, this.complemento_url.len):"")
            this.complemento_url = (pagina > 0  && this.complemento_url!=""? this.complemento_url+"&page="+pagina : this.complemento_url)
            return this.complemento_url
        },
        searchWebHooksUnity(getfiltro = 0){
            this.carregando = true
            this.erro = false
            //this.url_webhooks = this.url_webhooks+this.unitie.id
            
            if (getfiltro==1){

                this.getFiltrosComplementares();

            }
            console.log('this.complemento_url',this.complemento_url);
            console.log('this.url_search',this.url_search + this.complemento_url);


            
            
            var config = {
                method: 'get',
                url: this.url_search + this.complemento_url,
                // headers: {
                //         'Accept': 'application/json',
                //         'Authorization': this.$root.token(),
                //     },
                };
                //executa requisição
                axios(config)
                .then(response => {
                    this.lista_web_hook = response.data.webhooks
                    this.carregando = false
                })
                .catch(error => {
                    // erro exibido na própria tabela, com "Tentar novamente"
                    console.log('error',error);
                    this.erro = true
                    this.carregando = false
                    //this.erro = error
                    // console.log(error);
                });
                
                
        
        }
        
    },
    created(){
        // this.captados_webhook = this.webHooks;
        // console.log(this.captados_webhook);
        this.url_webhooks = this.url_webhooks+this.unitie.id
        this.url_search = this.url_search+this.unitie.id

        if(this.filtros.inscrito){

            this.filtro.nome_inscrito =  this.filtros.inscrito
        
        }
        if(this.filtros.WebHook){

            this.filtro.webhook_id =  this.filtros.WebHook
        }

        if(this.filtros.idcontato){

            this.filtro.contatoid =  this.filtros.idcontato
        }

        if(this.filtros.tipowebhook){

            this.filtro.tipoeventoaviso =  this.filtros.tipowebhook
        }

        if(this.filtros.sincronizado){

            this.filtro.sincronizado =  this.filtros.sincronizado
        }
    },
    mounted(){
       
       if((this.filtros.inscrito && this.filtros.inscrito!='') || (this.filtros.WebHook && this.filtros.WebHook!='') || (this.filtros.idcontato && this.filtros.idcontato!='') || (this.filtros.tipowebhook && this.filtros.tipowebhook!='') || (this.filtros.sincronizado && (this.filtros.sincronizado==1 || this.filtros.sincronizado==0))){
            this.searchWebHooksUnity(1);
       }else{
            this.getWebHooksUnity();
       }
       
    }
}
</script>

<style scoped>
    /* status com texto livre (mensagens do ERP/CRM) pode quebrar linha */
    .ec-tabela td.wh-col-status {
        white-space: normal;
        min-width: 7rem;
        max-width: 16rem;
    }

    /* link para as notas do webhook (abre em nova aba) */
    .wh-notas {
        display: inline-flex;
        align-items: center;
        gap: .35rem;
        padding: .2rem .55rem;
        border: 1px solid #e3e9ed;
        border-radius: 999px;
        font-size: .78rem;
        font-weight: 600;
        color: #1c4d5a;
        white-space: nowrap;
    }

    .wh-notas:hover,
    .wh-notas:focus {
        background: #1c4d5a;
        border-color: #1c4d5a;
        color: #fff;
        text-decoration: none;
    }

    .wh-notas--pendente {
        background: #fde4e4;
        border-color: #f7c5c5;
        color: #b42318;
    }

    /* ação indisponível: o tooltip fica no invólucro (botão desabilitado não dispara hover) */
    .wh-acao-indisponivel {
        display: inline-flex;
        cursor: not-allowed;
    }

    .wh-acao-indisponivel .ec-acao:disabled {
        pointer-events: none;
    }
</style>
